import { jsx as _jsx } from "react/jsx-runtime";
import '../../styles/components/ui-shared.css';
export function Avatar({ name, src, size = 'md', className = '' }) {
    const initials = name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    return (_jsx("div", { className: `avatar avatar-${size} ${className}`, title: name, children: src ? _jsx("img", { src: src, alt: name, className: "avatar-img" }) : _jsx("span", { children: initials }) }));
}
